import type { FetchFunction } from '#layers/base/public';
import { createStore } from '@rstore/vue';
import { createMonospacePlugin } from './plugins/2.monospace';
import { createWorkspaceSchema } from './schema/workspace';

/** Creates an isolated workspace RStore whose plugin CRUD and custom collection fetches share `fetch`. */
export async function createWorkspaceRStore(fetch: FetchFunction) {
	return await createStore({
		schema: createWorkspaceSchema(fetch),
		plugins: [createMonospacePlugin(fetch)],
		experimentalGarbageCollection: true,
	});
}
